module.exports = __webpack_public_path__ + "img/no-bg-logo.96c2723f.png";